import React from "react";

import styled from "styled-components";

import { AutomationCommandProps } from "../types/automation";

const TakeChartScreenshotCommand: React.FC<AutomationCommandProps> = () => {
  return <RootContainer>Take Chart Screenshot</RootContainer>;
};

export default TakeChartScreenshotCommand;
const RootContainer = styled.div``;
